export default "__VITE_ASSET__B0wZsN5D__"